import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const FERME = "FERME";

export const isStoreOpen = (openingTime?: string, closingTime?: string): boolean => {
  if (!openingTime || !closingTime) return true;
  if (openingTime === FERME || closingTime === FERME) return false;

  const now = dayjs().tz("Europe/Paris");
  const [openH, openM] = openingTime.split(":").map(Number);
  const [closeH, closeM] = closingTime.split(":").map(Number);

  const currentMinutes = now.hour() * 60 + now.minute();
  const openMinutes = openH * 60 + openM;
  const closeMinutes = closeH * 60 + closeM;

  return currentMinutes >= openMinutes && currentMinutes < closeMinutes;
};

export const formatStoreTime = (time: string): string => {
  if (time === FERME) return time;
  const [h, m] = time.split(":");
  return `${h}h${m}`;
};

export const parseStoreHours = (selectedStore?: { openingTime?: string; closingTime?: string } | null) => {
  const [openH] = selectedStore?.openingTime ? selectedStore.openingTime.split(':').map(Number) : [8];
  const [closeH, closeM] = selectedStore?.closingTime ? selectedStore.closingTime.split(':').map(Number) : [22, 0];
  const is24h = openH === 0 && closeH === 23 && closeM === 59;

  const openingHour = (() => {
    if (!selectedStore?.openingTime) return 8;
    if (is24h) return 0;
    return openH;
  })();

  const closingHour = (() => {
    if (!selectedStore?.closingTime) return 22;
    if (is24h) return 23;
    return closeM === 0 ? closeH : closeH + 1;
  })();

  return { openingHour, closingHour, is24h };
};
